import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import FormattedStorageSpace from "../common/FormattedStorageSpace";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "../common/tables";

const Details = ({ className, open, rows }) => {
  return (
    open && (
      <TableContainer className={className}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <FormattedMessage id="admin.subscriptions.storageSpace.workspaceName" />
              </TableCell>
              <TableCell>
                <FormattedMessage id="admin.subscriptions.storageSpace.desiredStorageSpace" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.workspaceName}>
                <TableCell>{row.workspaceName}</TableCell>
                <TableCell
                  align="right"
                  style={{ whiteSpace: "nowrap", verticalAlign: "top" }}
                >
                  <FormattedStorageSpace
                    storageSpace={row.desiredStorageSpace}
                    unit="GB"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
};

Details.defaultProps = {
  className: "",
  open: false,
  rows: [],
};

Details.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      desiredStorageSpace: PropTypes.number.isRequired,
      workspaceName: PropTypes.string.isRequired,
    })
  ),
};

export default Details;
